import { KoButton, KoDataTableEdit, KoForm,  KoNano, KoSelect } from 'packages';
import KoIcon from '@kwapio/icons';
import { useEffect, useState } from 'react';
import styles from './crud.module.scss';

function ItemEntryCrud({ form,handleFinish, initialValues}) {

  const [dataSource, setDataSource] = useState();

  useEffect(() => {
    if (initialValues?.agenda) {
      setDataSource(initialValues.agenda);
    } else {
      setDataSource([{
        key: KoNano('CAL'),
        title: null,
        presenter: null,
        dueDate: null,
        status: null
      }]);
    }
  }, [initialValues]);


  const DurationValues = [
    { label: '15 Mins', value: '15m' },
    { label: '30 Mins', value: '30m' },
    { label: '45 Mins', value: '45m' },
    { label: '1 Hour', value: '1h' },
    { label: '1.5 Hour', value: '1.5h' },
    { label: '2 Hour', value: '2h' },
    { label: '2.5 Hour', value: '2.5h' },
    { label: '3 Hour', value: '3h' },
    { label: '3.5 Hour', value: '3.5h' },
    { label: '4 Hour', value: '4h' },
    { label: '4.5 Hour', value: '4.5h' },
    { label: '5 Hour', value: '5h' },
    { label: '5.5 Hour', value: '5.5h' },
    { label: '6 Hour', value: '6h' },
    { label: '6.5 Hour', value: '6.5h' }
  ];


  const Duration = ({ value, onChange }) => {
    return (
      <KoSelect
        value={value}
        onChange={v => onChange(v)}
        showSearch
        allowClear
        placeholder='Choose duration'
        options={DurationValues}
       
      />
    );
  };

  const columns = [
    {
      dataIndex: 'title',
      title: 'Title',
      width: 200,
      editable: true,
      widget: 'text',
      placeholder: 'Title'
    },
    {
      dataIndex: 'presenter',
      title: 'Presenter',
      width: 200,
      editable: true,
      widget: 'text',
      placeholder: 'Presenter'
    },
    {
      dataIndex: 'duration',
      title: 'Duration',
      editable: true,
      width: 200,
      render: (text, record) => (
        <Duration
          value={record.duration}
          onChange={(newDuration) => {
            record.duration = newDuration;
          }}
        />
      )
    },

    {
      dataIndex: 'dueDate',
      title: 'Due Date',
      width: 200,
      editable: true,
      widget: 'date'
    },
    {
      title: ` `,
      dataIndex: 'operation',
      width: 40,
      render: (_, record, i) =>
        dataSource.length >= 1 ? (
          <div className={'editTableCol'}>
            <KoButton icon={<KoIcon width={12} height={12} name={'DeleteOutlined'} />} className={styles.actionBtn} onClick={() => handleDelete(record?.key)} label="" />
            {dataSource?.length === (i+1) && <KoButton icon={<KoIcon color={`var(--palette-gray-7)`} width={17} height={17} name={'PlusOutlined'} />} className={styles.actionBtn} onClick={() => handleAdd(record?.key)} label={``} />}
          </div>
        ) : null
    }
  ];

  const handleDelete = (key) => {
    let newData = dataSource.filter((item) => item.key !== key);
    setDataSource(newData);
    if(newData.length === 0){
      newData =[{
        key: KoNano('TAX'),
        taxName: null,
        taxRate: null,
        isDefault: false
      }];
    }
    handleSave(newData);
  };

  const handleAdd = () => {
    const newData = {
      key: KoNano('CAL'),
      title: ``,
      presenter: '',
      dueDate: '',
      status: ''
    };
    setDataSource([...dataSource, newData]);
  };

  const handleSave = (newData) => {
    let data = form.getFieldsValue();
    data['agenda'] = newData;
    form.setFieldsValue({...data});
    setDataSource(newData);
  };

  return (
    <div className={styles.itemwrapper}>
      <KoForm form={form} layout="vertical" onFinish={handleFinish} onSubmit={handleFinish}>
        <KoForm.Item name={'agenda'}>
          <KoDataTableEdit
            dataSource={dataSource}
            form={form}
            onSave={handleSave}
            defaultColumns={columns} />
        </KoForm.Item>
      </KoForm>
    </div>
  );
};

export default ItemEntryCrud;